import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bool, func, object, string } from 'prop-types';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import { Icon } from '@material-ui/core';

const MyButton = ({
  id,
  testId,
  className,
  style,
  content,
  disabled,
  href,
  name,
  onClick,
  variant = 'contained',
  target = '_self',
  color,
  startIcon,
  iconStyle,
  value,
  iconType,
}) =>
  ({
    contained: (
      <Button
        id={id}
        data-testid={testId}
        name={name}
        className={className}
        style={style}
        color="primary"
        disabled={disabled}
        fullWidth
        href={href}
        target={target}
        onClick={onClick}
        variant="contained"
      >
        <FormattedMessage {...content} />
      </Button>
    ),
    outlined: (
      <Button
        id={id}
        data-testid={testId}
        name={name}
        className={className}
        style={style}
        color="secondary"
        disabled={disabled}
        fullWidth
        href={href}
        target={target}
        onClick={onClick}
        variant="outlined"
      >
        <FormattedMessage {...content} />
      </Button>
    ),
    underlined: (
      <Button
        id={id}
        data-testid={testId}
        name={name}
        className={className}
        style={style}
        color="secondary"
        component={Link}
        disabled={disabled}
        fullWidth
        href={href}
        target={target}
        onClick={onClick}
        underline="always"
      >
        <FormattedMessage {...content} />
      </Button>
    ),
    custom: (
      <Button
        id={id}
        data-testid={testId}
        startIcon={startIcon}
        name={name}
        className={className}
        style={{ ...(disabled && { opacity: 0.6, color: '#888888' }), ...style }}
        color={color || 'secondary'}
        disabled={disabled}
        fullWidth
        href={href}
        target={target}
        onClick={onClick}
      >
        {iconType && <Icon component={iconType} fontSize="small" style={iconStyle} />}
        {value || <FormattedMessage {...content} />}
      </Button>
    ),
  })[variant];

MyButton.propTypes = {
  id: string,
  testId: string,
  className: string,
  style: object,
  content: object.isRequired,
  disabled: bool,
  href: string,
  name: string,
  onClick: func,
  variant: string,
  color: string,
  startIcon: object,
  iconStyle: object,
  value: string,
  iconType: object,
};

export default MyButton;
